import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import classnames from "classnames";
import styled from "styled-components";
import {
  Collapse,
  NavbarBrand,
  Navbar,
  NavItem,
  Nav,
  Container,
  DropdownToggle,
  UncontrolledDropdown,
  DropdownMenu,
  DropdownItem,
  NavLink as ReactstrapNavLink,
} from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PopUp from "@components/PopUp";
import DashboardConstant from "@views/Pages/Dashboard/landing-image.constant";

import Img from "@assets/img";
import { useSelector } from "react-redux";
import { RootState, clearStateAndPersist } from "@store/store";
import { API_END_POINTS } from "@utils/EndPoint";
import { useDispatch } from "react-redux";
import { EAppAction } from "@store/appReducer";
import * as S from "../components/PopUp/style";
import type { ThemeType } from "../../src/theme/tokens";
import HowItWorks from "@components/HowItWorks";
import { ThemeLogoFromCssVar } from "./HeaderBar/imageTheme";



export const Button = styled.button`
  display: flex;
  align-items: center;
  gap: 5px;
  border-radius: var(--border-radius-button, 30px);
  background: var(--primary-button-color);
  color: var(--primary-button-label-color, #fff);
  font-size: var(--font-size-sm, 16px);
  font-weight: var(--font-weight-medium, 500);

  &:hover {
    opacity: 0.9;
  }
`;

export const PopUpContainer = styled.div`
  width: 460px;
  display: flex;
  padding: var(--spacing-lg, 24px);
  flex-direction: column;
  justify-content: center;
  align-self: center;

  .popup-title {
    font-weight: var(--font-weight-bold, 700);
    font-size: var(--font-size-xl, 28px);
    line-height: var(--line-height-lg, 1.6);
    padding: var(--spacing-sm, 8px) var(--spacing-xl, 32px);
    color: var(--primary-label-color);
  }
`;

export const StyledCollapse = styled(Collapse)`
  justify-content: flex-end;
`;

export const NavWrapper = styled(Nav)`
  align-items: center;
`;

type ColorKey = keyof ThemeType["colors"];
interface NavItemLinkProps {
  colorKey?: ColorKey;
}

export const NavItemLink = styled(ReactstrapNavLink)<NavItemLinkProps>`
  text-decoration: none !important;
  color: var(--primary-color);
  font-size: var(--font-size-base, 18px);
  font-weight: var(--font-weight-medium, 500);
  padding: var(--spacing-xs, 4px) var(--spacing-md, 16px);
  &:hover {
    color: var(--hover-color) !important;
  }
  &.active {
    color: var(--focus-color) !important;
  }
`;


export const Ava = styled.span<{ bg: string }>`
  display: inline-block;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-size: cover;
  background-image: url(${(p) => p.bg});
`;

export const NavProfile = styled(Nav)`
  align-items: center;
`;

export const Profile = styled.div``;

// export const Button = styled.button`
//   display: flex;
//   align-items: center;
//   gap: 5px;
// `;

// export const PopUpContainer = styled.div`
//   width: 460px;
//   display: flex;
//   padding: 20px;
//   flex-direction: column;
//   justify-content: center;
//   align-self: center;
//   .popup-title {
//     font-weight: 700;
//     font-size: 28px;
//     line-height: 36px;
//     padding: 10px 40px;
//     color: orange;
//   }
// `;

const Navigate: React.FC = () => {
  const dispatch = useDispatch();
  const [navbarColor, setNavbarColor] = useState<string>("navbar-transparent");
  const [navbarCollapse, setNavbarCollapse] = useState<boolean>(false);
  const [isLogin, setIsLogin] = useState<boolean>(false);
  const [isLoginPage, setIsLoginPage] = useState<boolean>(false);
  const [visiblePopup, setVisiblePopup] = useState(false);
  const { user } = useSelector((state: RootState) => state.auth);
  const navigate = useNavigate();
  const location = useLocation();
  const [modalOpen, setModalOpen] = useState(false);

  const toggleModal = () => setModalOpen(!modalOpen);

  const toggleNavbarCollapse = () => {
    setNavbarCollapse(!navbarCollapse);
    document.documentElement.classList.toggle("nav-open");
  };

  useEffect(() => {
    if (location.pathname === API_END_POINTS.LOGIN) {
      setIsLoginPage(true);
    }

    const updateNavbarColor = () => {
      const scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollTop > 0) {
        setNavbarColor("");
      } else {
        setNavbarColor("navbar-transparent");
      }
    };

    window.addEventListener("scroll", updateNavbarColor);

    return () => {
      window.removeEventListener("scroll", updateNavbarColor);
    };
  }, []);

  const handleEarnGameTickets = () => {
    if (!user) {
      navigate("/login");
      return;
    }

    dispatch({
      type: EAppAction.SHOW_REFER_POPUP,
      payload: true,
    });
  };
  const logout = () => {
    clearStateAndPersist();
    navigate("/");
  };

  useEffect(() => {
    setIsLogin(!!user);
  }, [user]);

  useEffect(() => {
    document.documentElement.classList.remove("nav-open");
  }, []);

  return (
    <>

      <Navbar
        className={classnames("fixed-top", navbarColor)}
        color-on-scroll="300"
        expand="lg"
      // style={{ backgroundColor: "var(--secondary-label-color)" }}
      >
        <div className="w-full">
          <div className="navbar-translate">
            {/* <NavbarBrand
              data-placement="bottom"
              to="/"
              title="WNNR.IN"
              tag={Link}
            >
              <img src={
                themeName === "dabur"
                  ? navbarColor === "navbar-transparent"
                    ? DashboardConstant.Daburlogo
                    : DashboardConstant.DaburWhite
                  : robotImages[themeName] || robotImages.default
              } style={{ width: "var(--header-logo-size)" }} />
            </NavbarBrand> */}
            <ThemeLogoFromCssVar style={{ width: "var(--header-logo-size)" }} navbarColor={navbarColor} header={true} />
            <div style={{ display: "flex" }}>
              <Button
                hidden={!!user || isLoginPage}
                type="button"
                onClick={() => navigate(API_END_POINTS.LOGIN)}
                className="btn-round mr-1 lg-hide btn btn-primary"
              >
                Login <FontAwesomeIcon icon={["fas", "sign-in"]} />
              </Button>
              {/* <button
                aria-expanded={navbarCollapse}
                className={classnames("navbar-toggler navbar-toggler", {
                  toggled: navbarCollapse,
                })}
                onClick={toggleNavbarCollapse}
              >
                <span className="navbar-toggler-bar bar1" />
                <span className="navbar-toggler-bar bar2" />
                <span className="navbar-toggler-bar bar3" />
              </button> */}
            </div>
          </div>
          {/* <StyledCollapse navbar isOpen={navbarCollapse}>
            <NavWrapper navbar>
              <NavItem>
                <NavItemLink
                  to="/dashboard"
                  tag={Link}
                  className="navbar-item"
                  colorKey="gameslobby"
                >
                  Games Lobby
                </NavItemLink>
              </NavItem>
              <NavItem>
                <NavItemLink
                  onClick={toggleModal}
                  href="#"
                  className="navbar-item cursor-pointer"
                  colorKey="howitworks"
                >
                  How it works
                </NavItemLink>
              </NavItem>
              <NavItem>
                <NavItemLink
                  onClick={handleEarnGameTickets}
                  className="navbar-item"
                  colorKey="earngametickets"
                >
                  Earn Game Tickets
                </NavItemLink>
              </NavItem>
            </NavWrapper>
          </StyledCollapse> */}

          <Profile hidden={!isLogin}>
            <UncontrolledDropdown inNavbar>
              <DropdownToggle
                aria-expanded={false}
                aria-haspopup={true}
                color="default"
                data-toggle="dropdown"
                href=""
                nav
                onClick={(e) => e.preventDefault()}
                role="button"
              >
                <Ava bg={Img.Avatar} />
              </DropdownToggle>
              <DropdownMenu className="dropdown-danger dropdown-metadata" right>
                <DropdownItem
                  href=""
                  onClick={() => navigate(API_END_POINTS.PROFILE)}
                >
                  Profile
                </DropdownItem>
                <DropdownItem divider />
                <DropdownItem href="" onClick={() => setVisiblePopup(true)}>
                  Logout
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          </Profile>
          <Button
            hidden={!!user || isLoginPage}
            type="button"
            onClick={() => navigate(API_END_POINTS.LOGIN)}
            className="btn-round mr-1 mb-hide btn btn-primary"
          >
            Login <FontAwesomeIcon icon={["fas", "sign-in"]} />
          </Button>
        </div>
        <PopUp
          visible={visiblePopup}
          title="Gotta go?"
          footer={false}
          onOk={() => {
            setVisiblePopup(false);
            logout();
          }}
          onCancel={() => setVisiblePopup(false)}
          okText="No"
          cancelText="Yes"
        >
          <PopUpContainer>
            <div
              style={{
                display: "flex",
              }}
            >
              <div
                style={{
                  display: "flex",
                }}
              >
                <img src={Img.Mascot_1} alt="fire" width={180} />
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <div className="popup-title">Log Out Session?</div>
                <S.FooterModal>
                  <S.ButtonStyled
                    onClick={() => {
                      setVisiblePopup(false);
                      logout();
                    }}
                    style={{ marginRight: "15px", marginLeft: "10px" }}
                  >
                    Yes
                  </S.ButtonStyled>
                  <S.ButtonCancel
                    onClick={() => {
                      setVisiblePopup(false);
                    }}
                  >
                    No
                  </S.ButtonCancel>
                </S.FooterModal>
              </div>
              <div></div>
            </div>
          </PopUpContainer>
        </PopUp>
      </Navbar>


      <HowItWorks
        isOpen={modalOpen}
        toggle={toggleModal}
        videoUrl="https://youtu.be/V2pl_zeos70"
      />
    </>

  );
};

export default Navigate;
